import { render } from "./ExamDetailUpdate.vue?vue&type=template&id=8803202e&scoped=true"
import script from "./ExamDetailUpdate.vue?vue&type=script&lang=js"
export * from "./ExamDetailUpdate.vue?vue&type=script&lang=js"

import "./ExamDetailUpdate.vue?vue&type=style&index=0&id=8803202e&scoped=true&lang=less"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8803202e"]])

export default __exports__